/* global G */
import find from 'lib/sequence/component/children/find'
import { asyncPipeSpread } from 'lib/util'
import displaySpentTime from '../partials/displaySpentTime'

/**
 * Ticket stop action.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => () => async (...args) => asyncPipeSpread(
  displaySpentTime(module),
)(find(module[G.STATE][G.ACTION][G.COMPONENT]), ...args)
